import { IPSpinner, IPStack } from 'baseComponents';
import { globalStackStylesNoHeightPaddingSmall, globalStackTokensGapLarge } from 'globalStyles';

//
// The loader of a scene: a lazy scene that is still loading, or a sign-in in progress.
//
const SceneLoader = () => {
  return (
    <IPStack
      verticalFill
      horizontalAlign="center"
      verticalAlign="center"
      styles={globalStackStylesNoHeightPaddingSmall}
      tokens={globalStackTokensGapLarge}
    >
      <IPSpinner size="large" />
    </IPStack>
  );
};

export default SceneLoader;
